export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const btnScrollTopEl = $('.lvr-btn-scroll-top');
    if (btnScrollTopEl && btnScrollTopEl.length > 0) {
      btnScrollTopEl.click(evt => {
        evt.preventDefault();
        evt.stopPropagation();
        $('html, body').animate({scrollTop: 0}, 500);
        return false;
      });
    }

    //---> BEGIN: Handle sidebar menu
    $('.sidebar-menu a[href=#verzekeringen]').click(() => {
      $('#showInsuranceModal').click();
      return false;
    });

    const handleHideSidebar = () => {
      $('.lvr-sidebar-menu-wrap').removeClass('show');
      setTimeout(() => {
        $('.lvr-sidebar-menu-wrap').css('visibility', 'hidden');
      }, 300);
    };

    const handleShowSidebar = () => {
      $('.lvr-sidebar-menu-wrap').addClass('show').css('visibility', 'visible');
    };

    const handleToggleSidebarMenu = ($this, isClickOutSide = false) => {
      const imgEl = $this.find('img');
      let imgSrc = imgEl.attr('src');
      const result = /[^/]*$/.exec(imgSrc)[0];

      if (isClickOutSide) {
        if (result === 'toggler-close.png') {
          imgSrc = imgSrc.replace(result, 'toggler.png');
          handleHideSidebar();
        }
      } else {
        if (result === 'toggler.png') {
          imgSrc = imgSrc.replace(result, 'toggler-close.png');
          handleShowSidebar();
        } else {
          imgSrc = imgSrc.replace(result, 'toggler.png');
          handleHideSidebar();
        }
      }

      imgEl.attr('src', imgSrc);
    };

    const btnToggleSibarEl = '#lvr-sidebar-toggler';
    $(btnToggleSibarEl).click(evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const $this = $(evt.currentTarget);
      handleToggleSidebarMenu($this);
    });

    // Hide sidebar when click outside
    $(document).click(function (evt) {
      evt.stopPropagation();
      const container = $('.lvr-sidebar-menu-wrap');

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(evt.target) && container.has(evt.target).length === 0) {
        const thisEl = $(btnToggleSibarEl).get()[0];
        handleToggleSidebarMenu($(thisEl), true);
      }
    });

    //---> END: Handle sidebar menu

    setTimeout(() => {
      $('.lvr-loading-indicator-wrap').addClass('loaded');
    }, 200);

    // galley slider
    //---> Carousel
    const galerryCarousel = $('#lvr-gallery-carousel .owl-carousel');
    galerryCarousel.owlCarousel({
      margin: 20,
      loop: true,
      responsiveClass: true,
      items: 3,
      autoWidth: true,
      autoPlay: true,
      320: {
        items: 1,
      },
      // breakpoint from 414 up
      414: {
        items: 2,
        margin: 15,
      },
      // breakpoint from 768 up
      768: {
        items: 3,
      },
    });

    $('#lvr-gallery-carousel .lvr-owl-next').click(function () {
      galerryCarousel.trigger('next.owl.carousel', [300]);
    });
    // Go to the previous item
    $('#lvr-gallery-carousel .lvr-owl-prev').click(function () {
      galerryCarousel.trigger('prev.owl.carousel', [300]);
    });

    const galleryModalEl = '#galleryModal';
    $(galleryModalEl).on('show.bs.modal', function () {
      setTimeout(() => {
        if ($('.modal-backdrop') && $('.modal-backdrop').length > 0) {
          $('.modal-backdrop').addClass('lvr-modal-backdrop');
        }
      }, 100);
    });

    const showGalleryModal = () => {
      $(galleryModalEl).modal('show');
    };

    const hideGalleryModal = () => {
      $(galleryModalEl).modal('hide');
    };

    const handleHideGalleryDetails = el => {
      // Showing gallery grid
      $('.lvr-gallery-grid').removeClass('d-none');

      // Hiding gallery details
      $('.lvr-gallery-detail').addClass('d-none');

      el.attr('data-is-details', 'false');
    };

    //---> Handle modal when show on responsive -- reset height
    const handleModalWhenResponsive = ({isDetails = false}) => {
      if (isDetails) {
        $('#galleryModal .modal-content').addClass('mode-details');
        return;
      }
      $('#galleryModal .modal-content').removeClass('mode-details');
    };

    //---> Hide modal
    $(`${galleryModalEl} .btn-close-modal`).click(evt => {
      const $this = $(evt.currentTarget);
      const isDetails = $this.attr('data-is-details') === 'true' ? true : false;
      if (isDetails) {
        handleHideGalleryDetails($this);
        handleModalWhenResponsive({isDetails: false});
      } else {
        hideGalleryModal();
        handleHideGalleryDetails($this);
      }
    });

    /**
     * Updating gallery information (media source, description)
     * @param {*} mediaSrc
     * @param {*} mediaDescription
     * @param {*} currentPage
     * @param {*} totalPage
     */
    const updateGalleryItemInfo = ({
      mediaSrc,
      mediaDescription,
      currentPage,
      totalPage,
    }) => {
      $('.lvr-gallery-slider-item img').attr('src', mediaSrc);
      $('.lvr-gallery-slider-item .lvr-gallery-description').html(
        mediaDescription
      );
      $('.lvr-gallery-detail .lvr-page-number').text(
        currentPage // parseInt(currentIdx) + 1
      );
      $('.lvr-gallery-detail .lvr-total-page').text(totalPage);
    };

    const handleLoadActiveGallery = ({currentMediaEl, currentIdx}) => {
      if (currentMediaEl && currentMediaEl.length > 0) {
        const mediaSrc = currentMediaEl.attr('data-media-src');
        const mediaDescription = currentMediaEl.attr('data-media-description');
        const currentPage = parseInt(currentIdx) + 1;
        const totalPage = galleryItemEl.length;
        updateGalleryItemInfo({
          mediaSrc,
          mediaDescription,
          currentPage,
          totalPage,
        });
        $('.slider-actions').attr('data-current-index', currentIdx);
      }
    };

    //---> Handle click on gallery item -> show gallery details
    const galleryItemEl = $('.lvr-media-item-wrap .lvr-item-overlay');

    if (galleryItemEl && galleryItemEl.length > 0) {
      galleryItemEl.click(evt => {
        const $this = $(evt.currentTarget);
        const modalCloseBtn = $this
          .closest('.modal-content')
          .find('.lvr-btn-modal-back');
        const currentIdx = $this.attr('data-item-index');

        // Add mode details for back button
        if (modalCloseBtn && modalCloseBtn.length) {
          modalCloseBtn.attr('data-is-details', 'true');
        }

        // Hiding gallery grid
        $('.lvr-gallery-grid').addClass('d-none');

        // Showing gallery details
        $('.lvr-gallery-detail').removeClass('d-none');

        // Get element by current index
        const currentMediaEl = $this.parent('.lvr-media-item-wrap');
        handleLoadActiveGallery({currentMediaEl, currentIdx});
        handleModalWhenResponsive({isDetails: true});
      });
    }

    // Handle click prev/next
    $('.slider-actions .slider-btn').click(evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const $this = $(evt.currentTarget);
      const isNext = $this.attr('data-type') === 'next' ? true : false;
      const currentIdx = $this
        .closest('.slider-actions')
        .attr('data-current-index');

      if (isNext) {
        const nextIdx = parseInt(currentIdx) + 1;
        const nextItemEl = $('.lvr-media-item-wrap').get(nextIdx);
        if (nextIdx <= $('.lvr-media-item-wrap').length) {
          handleLoadActiveGallery({
            currentMediaEl: $(nextItemEl),
            currentIdx: nextIdx,
          });
        }
      } else {
        const prevIdx = parseInt(currentIdx) - 1;
        const prevItemEl = $('.lvr-media-item-wrap').get(prevIdx);
        if (prevIdx >= 0) {
          handleLoadActiveGallery({
            currentMediaEl: $(prevItemEl),
            currentIdx: prevIdx,
          });
        }
      }
    });

    // Handle click on button show 15 photo
    const handleClickOnButtonShowPhoto = () => {
      $(
        '#lvr-gallery-carousel .lvr-banner-btn, #lvr-gallery-carousel .lvr-zoom-btn'
      ).click(evt => {
        evt.preventDefault();
        evt.stopPropagation();
        showGalleryModal();
      });
    };
    handleClickOnButtonShowPhoto();
    //---> END: Script for Accommodation details page

    //---> BEGIN: Script for Review with Truspilot
    const reviewCarousel = $('.lvr-review-list');
    const initTrustpilotCarousel = () => {
      reviewCarousel.owlCarousel({
        loop: true,
        margin: 0,
        responsiveClass: true,
        dots: false,
        nav: false,
        singleItem: true,
        items: 1,
      });
      reviewCarousel.owlCarousel();

      // Go to the next item
      $('.lvr-carousel-actions .lvr-next-icon').click(function () {
        reviewCarousel.trigger('next.owl.carousel');
      });

      // Go to the previous item
      $('.lvr-carousel-actions .lvr-prev-icon').click(function () {
        reviewCarousel.trigger('prev.owl.carousel', [300]);
      });

      // Listen to owl events:
      reviewCarousel.on('changed.owl.carousel', function (event) {
        const currentIdx = event.item.index - 2;
        const listGroupItemsEl = $('.lvr-group-list .lvr-group-item');
        const listGroupItemsElActive = $('.lvr-group-list .lvr-group-item').get(
          currentIdx
        );

        if (listGroupItemsEl && listGroupItemsEl.length > 0) {
          listGroupItemsEl.removeClass('active');
        }

        if (
          listGroupItemsElActive &&
          $(listGroupItemsElActive) &&
          $(listGroupItemsElActive).length > 0
        ) {
          $(listGroupItemsElActive).addClass('active');
        }
      });
    };
    // Init trustpilot carousel.
    initTrustpilotCarousel();

    // Handler click group item
    $('.lvr-group-list .lvr-group-item').click(evt => {
      const $this = $(evt.currentTarget);
      const currentIdx = $this.index();

      reviewCarousel.trigger('to.owl.carousel', [currentIdx]);
    });
    //---> END: Script for Review with Truspilot

    //---> BEGIN: Script for style LVR form
    const formInputEl = $(
      '.lvr-form-wrap input, .lvr-form-wrap select, .lvr-form-wrap textarea'
    );

    const handleFormLabelValid = el => {
      el.removeClass('d-none');
      el.siblings('.lvr-label-text').addClass('lvr-color-9');
    };

    const handleFormLabelInvalid = el => {
      el.addClass('d-none');
      el.siblings('.lvr-label-text').removeClass('lvr-color-9');
    };

    const setStyleEnteredValue = () => {
      formInputEl.each(function () {
        const labelIconEl = $(this)
          .closest('.lvr-form-control')
          .find('.lvr-form-label .lvr-icon-wrap');
        if ($(this).val()) {
          $(this).addClass('lvr-has-value');
          handleFormLabelValid(labelIconEl);
        } else {
          $(this).removeClass('lvr-has-value');
          handleFormLabelInvalid(labelIconEl);
        }
      });
    };
    setStyleEnteredValue();

    if (formInputEl && formInputEl.length > 0) {
      formInputEl.change(evt => {
        const $this = $(evt.currentTarget);
        const controlValue = $this.val();
        const labelIconEl = $this
          .closest('.lvr-form-control')
          .find('.lvr-form-label .lvr-icon-wrap');
        if (controlValue) {
          if($this.hasClass('number')){ // check if input is number
            if(parseInt(controlValue) > 0){
              $this.addClass('lvr-has-value');
              handleFormLabelValid(labelIconEl);
            }else{
              $this.removeClass('lvr-has-value');
              handleFormLabelInvalid(labelIconEl);
            }
          }else{
            $this.addClass('lvr-has-value');
            handleFormLabelValid(labelIconEl);
          }
        } else {
          $this.removeClass('lvr-has-value');
          handleFormLabelInvalid(labelIconEl);
        }
      });
    }

    const setBoldChecked = () => {
      const checkboxEl = $('.lvr-checkbox:checked');
      const labelIconEl = $('.lvr-checkbox')
        .closest('.lvr-form-control')
        .find('.lvr-form-label .lvr-icon-wrap');
      if (checkboxEl && checkboxEl.length > 0) {
        checkboxEl
          .closest('.lvr-form-checkbox')
          .find('.lvr-checkbox-text')
          .addClass('font-weight-bold');

        handleFormLabelValid(labelIconEl);
      } else {
        checkboxEl
          .closest('.lvr-form-checkbox')
          .find('.lvr-checkbox-text')
          .remove('font-weight-bold');
        handleFormLabelInvalid(labelIconEl);
      }

      const radioEl = $('.lvr-radio:checked');
      if (radioEl && radioEl.length > 0) {
        radioEl
          .closest('.lvr-form-radio')
          .find('.lvr-radio-text')
          .addClass('font-weight-bold');
      }
    };
    setBoldChecked();

    $('.lvr-checkbox').change(evt => {
      const $this = $(evt.currentTarget);
      const labelIconEl = $this
        .closest('.lvr-form-control')
        .find('.lvr-form-label .lvr-icon-wrap');
      const isChecked = $this.prop('checked');
      if (isChecked) {
        $this
          .closest('.lvr-form-checkbox')
          .addClass('checked')
          .find('.lvr-checkbox-text')
          .addClass('font-weight-bold');
      } else {
        $this
          .closest('.lvr-form-checkbox')
          .removeClass('checked')
          .find('.lvr-checkbox-text')
          .removeClass('font-weight-bold');
      }

      // Handle show/hide check icon label
      const checkboxCheckedEl = $('.lvr-checkbox:checked');
      if (checkboxCheckedEl && checkboxCheckedEl.length > 0) {
        handleFormLabelValid(labelIconEl);
      } else {
        handleFormLabelInvalid(labelIconEl);
      }
    });

    $('.lvr-radio').change(evt => {
      const $this = $(evt.currentTarget);
      const isChecked = $this.prop('checked');
      const nameArr = $this.prop('name');
      if (isChecked) {
        $this
          .closest('.lvr-form-radio')
          .find('.lvr-radio-text')
          .addClass('font-weight-bold');
        $(`.lvr-radio[name="${nameArr}"]`)
          .not($this)
          .closest('.lvr-form-radio')
          .find('.lvr-radio-text')
          .removeClass('font-weight-bold');
      } else {
        $this
          .closest('.lvr-form-radio')
          .find('.lvr-radio-text')
          .removeClass('font-weight-bold');
      }
    });
    //---> END: Script for style LVR form

    //---> BEGIN: Handle script for fullscreen modal
    const fullscrennModalId = '#fullscreenModal';
    $(`${fullscrennModalId} .btn-close-modal`).click(evt => {
      evt.preventDefault();
      $(fullscrennModalId).modal('hide');
    });

    $(fullscrennModalId).on('show.bs.modal', () => {
      setTimeout(() => {
        if ($('.modal-backdrop') && $('.modal-backdrop').length > 0) {
          $('.modal-backdrop').addClass('lvr-modal-backdrop');
        }
      }, 100);
      const imgSrc = $('.lvr-ski-area-img-wrap img').attr('src');
      $('.fullscreen-image img').attr('src', imgSrc);
    });
    //---> END: Handle script for fullscreen modal

    //---> BEGIN: Handle show/hide post content
    $('.lvr-show-more-post').click(evt => {
      evt.preventDefault();
      const $this = $(evt.currentTarget);
      const postContentEl = $this.siblings('.lvr-post-content');
      const truncateContentClass = 'truncate-content';
      if (postContentEl.hasClass(truncateContentClass)) {
        postContentEl.removeClass(truncateContentClass);
      } else {
        postContentEl.addClass(truncateContentClass);
      }
      // Hide button show more
      $this.addClass('d-none');
    });
    //---> END: Handle show/hide post content

    //---> BEGIN: Handle change label text offerte form
    const screenWidth = $(window).width();
    const handleReplaceTextFormMobile = () => {
      const amountSkiDay = $('.offe-amount-ski-days .lvr-label-text');
      const amountOvernightStays = $(
        '.offe-amount-overnight-stays .lvr-label-text'
      );
      const infoGroupSchool = $('.offe-info-group-school .lvr-label-text');
      const comment = $('.offe-comment .lvr-label-text');

      if (screenWidth < 768) {
        amountSkiDay.text('Skidagen');
        amountOvernightStays.text('Overnachtingen');
        infoGroupSchool.text('Informatie over verzekeringen');
        comment.text('Eventuele vragen, opmerkingen of suggesties');
      } else {
        amountSkiDay.text('Aantal Skidagen');
        amountOvernightStays.text('Aantal Overnachtingen');
        comment.text(
          'Eventuele vragen, opmerkingen of suggesties kun je hier kwijt'
        );
      }
    };
    handleReplaceTextFormMobile();

    //---> END: Handle change label text offerte form

    // Handle show/hide content corona pageBreakAfter:  //---> BEGIN: Handle show/hide post content
    $('.lvr-other-info-item-content .lvr-morelink').click(evt => {
      evt.preventDefault();
      const $this = $(evt.currentTarget);
      const postContentEl = $this.siblings('.info-content-wrap');
      const truncateContentClass = 'truncate-content';
      if (postContentEl.hasClass(truncateContentClass)) {
        postContentEl.removeClass(truncateContentClass);
        // Hide button show more
        $this.text('Show less');
      } else {
        postContentEl.addClass(truncateContentClass);
        // Hide button show more
        $this.text('Less meer');
      }
    });

    const handleReadMoreText = () => {
      const screenW = $(window).width();

      if (screenW < 768) {
        const elem = $('.lvr-other-info-item-content .info-content-wrap');
        elem.each(function () {
          const elHeight = $(this)[0].clientHeight;
          const elReadmore = $(this)
            .closest('.lvr-other-info-item-content')
            .find('.lvr-morelink');
          if (elHeight >= 144) {
            elReadmore.removeClass('d-none');
          } else {
            elReadmore.addClass('d-none');
          }
        });
      }
    };
    handleReadMoreText();
    //---> END: Handle show/hide post content
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js